import { render, staticRenderFns } from "./AddLandlords.vue?vue&type=template&id=16d149bd&scoped=true"
import script from "./AddLandlords.vue?vue&type=script&lang=js"
export * from "./AddLandlords.vue?vue&type=script&lang=js"
import style0 from "./AddLandlords.vue?vue&type=style&index=0&id=16d149bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d149bd",
  null
  
)

export default component.exports